<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.num')">
                    <el-select
                      v-model="formInline.selectCarType"
                      style="width: 120px"
                      :placeholder="$t('common.choseTip')"
                      class="selectStyle"
                    >
                      <el-option
                        v-for="item in optionsInput"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      size="mini"
                      v-model="formInline.selectCarValue"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="inputStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('DriverManagement.driverExpiresType')"
                  >
                    <el-select
                      v-model="formInline.carExpiresType"
                      :placeholder="$t('DriverManagement.driverExpiresType')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in StateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.driverExpires')">
                    <el-date-picker
                      v-model="formInline.carExpiresTime"
                      type="daterange"
                      style="width: 220px"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.choseTime')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('VEHICLEANNUALREVIEW_VEHICLEANNUAL')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="carAnnualReview"
                  >{{ $t("NavMenu.VehicleAnnualReview") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('VEHICLEANNUALREVIEW_APPROVALPROGRESS')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="ApprovalProgress"
                  >{{ $t("VehicleManagement.btn.approvalProgress") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('VEHICLEANNUALREVIEW_DOWN')"
                  type="text"
                  @click="downCar"
                  >{{ $t("common.btn.download") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="800px"
        :before-close="closeDia"
        class="carDialong"
        :title="$t('NavMenu.VehicleAnnualReview')"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="carId"
            :label="$t('common.carId') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.carId"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="manufactureNum"
            :label="$t('common.manufactureNum') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.manufactureNum"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="customNum"
            :label="$t('common.customNum') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.customNum"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="plateNum"
            :label="$t('common.plateNum') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.plateNum"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="carExpires"
            :label="$t('VehicleManagement.currentExpirationDate') + ':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              :disabled="disabled"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.choseTime')"
              v-model="form.carExpires"
              style="width: 500px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="expiresInstitution"
            :label="$t('VehicleManagement.annualReviewName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.expiresInstitution"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="carExpiresNum"
            :label="$t('VehicleManagement.annualReviewCode') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.carExpiresNum"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="changeExpireDate"
            :label="$t('VehicleManagement.changeExpireDate') + ':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.choseTime')"
              v-model="form.changeExpireDate"
            ></el-date-picker>
          </el-form-item>
          <div>
            <el-form-item
              prop="filePath"
              :label="$t('common.picture') + ':'"
              :label-width="formLabelWidth"
              style="width: 340px"
            >
              <el-upload
                class="picStyle"
                :action="processImg"
                :show-file-list="false"
                :file-list="FileList"
                :on-success="handleAvatarSuccess"
                :on-remove="handleRemove"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatars" />
                <i v-else class="el-icon-plus avatars-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="1200px"
        :before-close="closeOperateDia"
        class="tableDialong"
        :title="$t('VehicleManagement.btn.approvalProgress')"
        :visible.sync="dialogOperateFormVisible"
        :close-on-click-modal="false"
      >
        <div class="zMsgBtn">
          <el-button
            type="text"
            :disabled="select.length != 1"
            @click="reAnnualReview"
            >{{ $t("VehicleManagement.reAnnualReview") }}</el-button
          >
        </div>
        <div class="zMsgTable">
          <i-table
            :list="operatesList"
            :height="operatesHeight"
            ref="operatesTable"
            @handleSelectionChange="handleOperatesChange"
            :options="option"
            :columns="allColumns"
            :operates="allOperates"
          ></i-table>
          <IPagination
            ref="OperatesPage"
            @PageFun="changeOperatesSize"
          ></IPagination>
        </div>
      </el-dialog>
      <el-dialog
        width="90%"
        class="tableDialong"
        :before-close="closeImgDia"
        :title="$t('common.picture')"
        :visible.sync="dialogImgFormVisible"
      >
        <img :src="imgUrl" style="width: 100%" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import VehicleAnnualReview from "./VehicleAnnualReview.js";
export default VehicleAnnualReview;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
